import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["ReadingProgress"] */ "/app/src/components/blog/reading-progress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollProgressBar"] */ "/app/src/components/blog/scroll-progress-bar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/motion-wrapper.tsx");
